// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contConsolaHost{
    width: 95%;
    height: 85%;
    top: 3%;
    position: relative;
    border: 2px solid rgba(143, 142, 142, 0.685);
    border-radius: 10px;
    background-color: rgba(3, 6, 14, 0.452);
    display: flex;
    justify-content: center;
    align-items: center;
}

.contConsolaHost .contConsolText{
    width: 98%;
    height: 95%;
    /* overflow-x: auto; */
    overflow-x: hidden;
}
.contConsolText{
    scroll-behavior: auto;
}.contConsolText .command-container{
    display: flex;
    left: 1%;
    top: 17px;
    margin-bottom: 2px;
    position: relative;
    color: rgb(109, 194, 159);
    font-size: small;
    width: 98%;
  }
.contConsolText .prompt{
    left: 1%;
    top: 12px;
    margin-bottom: 2px;
    position: relative;
    color: rgb(109, 194, 159);
    font-size: small;
    width: 98%;
}
.contConsolText .prompt:last-child{
    background-color: #3f3f3f1e;
    margin-bottom: 10px;
    height: 10%;
    width: 98%;
    display: flex;
    justify-content: start;
    align-items: center;
}
.command-input:focus-visible {
    outline: none;
    border-color: rgba(109, 194, 159, 0.425) !important;
    border-left: rgba(109, 194, 159, 0.719);
  }
  .command-input:focus {
    outline: none;
    
  }
.contConsolText .prompt .command-input{
    background-color: transparent;
    width: 81%;
    background-color: transparent;
       border-radius: 5px;
       border-top: unset;
       border-left: unset;
       border-color: rgb(141, 141, 141);
       color: aliceblue;
       margin-left: 1%;
       letter-spacing: 1px;
}
.contConsolText .responseDiv p:nth-child(1) {
    display: none;
  }
  .contConsolText .successMessage{
    color: lime;
    left: 2%;
    top: 13px;
    margin-bottom: 10px;
    position: relative;
    font-size: small;
    width: 96%;
    /* font-family: console; */
    font-family:  "Roboto" !important
  }
  .contConsolText .cancelDiv{
    color: red;
    left: 2%;
    top: 13px;
    margin-bottom: 10px;
    position: relative;
    font-size: small;
    width: 96%;
    font-family:  "Roboto" !important
  }
  .contConsolText .startDiv{
    left: 2%;
    top: 13px;
    margin-bottom: 10px;
    position: relative;
    color: rgba(218, 218, 218, 0.911);
    font-size: small;
    width: 96%;
    font-family:  "Roboto" !important
  }
  
  .contConsolText .command-container .commandReq{
    color: aliceblue;
    left: 1%;
  }
.contConsolaHost .contConsoloptions{
    border: 1px solid rgba(240, 248, 255, 0.301);
    width: 100%;
    height: 20%;

    display: flex;
    justify-content: center;
    align-items: center;
}
.contConsolText .responseDiv{
    left: 2%;
  top: 5px;
  margin-bottom: 10px;
  position: relative;
  color: rgba(218, 218, 218, 0.911);
  font-size: small;
  width: 96%;
  /* font-family: console; */
  font-family:  "Roboto" !important
}
.contConsolText .contResponseDiv{
    left: 2%;
  top: 1px;
  margin-bottom: 10px;
  position: relative;
  color: rgba(218, 218, 218, 0.911);
  font-size: small;
  width: 96%;
  /* font-family: console; */
  font-family:  "Roboto" !important;
  height: auto;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  box-sizing: border-box;
}
.contInputConsole{
    width: 80%;
    height: 70%;
    /* background-color: aliceblue; */
    display: flex;
    justify-content: start;
    align-items: center;
}
.contActionsConsole{
    width: 20%;
    height: 70%;
    background-color: rgb(42, 90, 131);
    display: flex;
    justify-content: center;
}
.contInputConsole .lblConsole{
     width: 10%;
     height: 100%;
     display: flex;
     justify-content: center;
     align-items: center;
     color: rgb(141, 141, 141);
     font-size: large;
}

.contInputConsole .inptConsole{
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
}
.inptConsole input{
    animation: 'pulse 1s infinite';
        border-bottom: '1px solid aliceblue'; 
       width: 90%;
       height: 50%;
       background-color: transparent;
       border-radius: 5px;
       border-top: unset;
       border-left: unset;
       border-color: rgb(141, 141, 141);
       color: aliceblue;
}
.inptConsole input:focus-visible{
    border-top: unset;
       border-left: unset;
       border-color: rgba(1, 175, 206, 0.699);
}
.contConsolTitle{
    width: 100%;
    height: 10%;
    color: var(--main-color);
    font-size: var(--font-size-small);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
}
@keyframes pulse {
    0% {
      color: #d41e1e; /* Color inicial */
    }
    50% {
      color: transparent; /* Color transparente */
    }
    100% {
      color: #000; /* Color final */
    }
  }

  .contConsolTitle .cont-btn-back-users:hover{
    background: transparent;
cursor: unset;
  }
  .contConsolTitle .img-back-users:hover{
    height: 85%;
    cursor: pointer;
  }
  .contConsolText .xterm-viewport{
background-color: transparent !important;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/ConsolaHost.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB,CAAC;IACG,aAAa;IACb,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;EACZ;AACF;IACI,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mDAAmD;IACnD,uCAAuC;EACzC;EACA;IACE,aAAa;;EAEf;AACF;IACI,6BAA6B;IAC7B,UAAU;IACV,6BAA6B;OAC1B,kBAAkB;OAClB,iBAAiB;OACjB,kBAAkB;OAClB,gCAAgC;OAChC,gBAAgB;OAChB,eAAe;OACf,mBAAmB;AAC1B;AACA;IACI,aAAa;EACf;EACA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,0BAA0B;IAC1B;EACF;EACA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV;EACF;EACA;IACE,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,UAAU;IACV;EACF;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;IACI,4CAA4C;IAC5C,WAAW;IACX,WAAW;;IAEX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,QAAQ;EACV,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B;AACF;AACA;IACI,QAAQ;EACV,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;IACI,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,aAAa;IACb,uBAAuB;AAC3B;AACA;KACK,UAAU;KACV,YAAY;KACZ,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,yBAAyB;KACzB,gBAAgB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,8BAA8B;QAC1B,oCAAoC;OACrC,UAAU;OACV,WAAW;OACX,6BAA6B;OAC7B,kBAAkB;OAClB,iBAAiB;OACjB,kBAAkB;OAClB,gCAAgC;OAChC,gBAAgB;AACvB;AACA;IACI,iBAAiB;OACd,kBAAkB;OAClB,sCAAsC;AAC7C;AACA;IACI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;AACV;AACA;IACI;MACE,cAAc,EAAE,kBAAkB;IACpC;IACA;MACE,kBAAkB,EAAE,uBAAuB;IAC7C;IACA;MACE,WAAW,EAAE,gBAAgB;IAC/B;EACF;;EAEA;IACE,uBAAuB;AAC3B,aAAa;EACX;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;AACF,wCAAwC;EACtC","sourcesContent":[".contConsolaHost{\r\n    width: 95%;\r\n    height: 85%;\r\n    top: 3%;\r\n    position: relative;\r\n    border: 2px solid rgba(143, 142, 142, 0.685);\r\n    border-radius: 10px;\r\n    background-color: rgba(3, 6, 14, 0.452);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.contConsolaHost .contConsolText{\r\n    width: 98%;\r\n    height: 95%;\r\n    /* overflow-x: auto; */\r\n    overflow-x: hidden;\r\n}\r\n.contConsolText{\r\n    scroll-behavior: auto;\r\n}.contConsolText .command-container{\r\n    display: flex;\r\n    left: 1%;\r\n    top: 17px;\r\n    margin-bottom: 2px;\r\n    position: relative;\r\n    color: rgb(109, 194, 159);\r\n    font-size: small;\r\n    width: 98%;\r\n  }\r\n.contConsolText .prompt{\r\n    left: 1%;\r\n    top: 12px;\r\n    margin-bottom: 2px;\r\n    position: relative;\r\n    color: rgb(109, 194, 159);\r\n    font-size: small;\r\n    width: 98%;\r\n}\r\n.contConsolText .prompt:last-child{\r\n    background-color: #3f3f3f1e;\r\n    margin-bottom: 10px;\r\n    height: 10%;\r\n    width: 98%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n.command-input:focus-visible {\r\n    outline: none;\r\n    border-color: rgba(109, 194, 159, 0.425) !important;\r\n    border-left: rgba(109, 194, 159, 0.719);\r\n  }\r\n  .command-input:focus {\r\n    outline: none;\r\n    \r\n  }\r\n.contConsolText .prompt .command-input{\r\n    background-color: transparent;\r\n    width: 81%;\r\n    background-color: transparent;\r\n       border-radius: 5px;\r\n       border-top: unset;\r\n       border-left: unset;\r\n       border-color: rgb(141, 141, 141);\r\n       color: aliceblue;\r\n       margin-left: 1%;\r\n       letter-spacing: 1px;\r\n}\r\n.contConsolText .responseDiv p:nth-child(1) {\r\n    display: none;\r\n  }\r\n  .contConsolText .successMessage{\r\n    color: lime;\r\n    left: 2%;\r\n    top: 13px;\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n    font-size: small;\r\n    width: 96%;\r\n    /* font-family: console; */\r\n    font-family:  \"Roboto\" !important\r\n  }\r\n  .contConsolText .cancelDiv{\r\n    color: red;\r\n    left: 2%;\r\n    top: 13px;\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n    font-size: small;\r\n    width: 96%;\r\n    font-family:  \"Roboto\" !important\r\n  }\r\n  .contConsolText .startDiv{\r\n    left: 2%;\r\n    top: 13px;\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n    color: rgba(218, 218, 218, 0.911);\r\n    font-size: small;\r\n    width: 96%;\r\n    font-family:  \"Roboto\" !important\r\n  }\r\n  \r\n  .contConsolText .command-container .commandReq{\r\n    color: aliceblue;\r\n    left: 1%;\r\n  }\r\n.contConsolaHost .contConsoloptions{\r\n    border: 1px solid rgba(240, 248, 255, 0.301);\r\n    width: 100%;\r\n    height: 20%;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.contConsolText .responseDiv{\r\n    left: 2%;\r\n  top: 5px;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n  color: rgba(218, 218, 218, 0.911);\r\n  font-size: small;\r\n  width: 96%;\r\n  /* font-family: console; */\r\n  font-family:  \"Roboto\" !important\r\n}\r\n.contConsolText .contResponseDiv{\r\n    left: 2%;\r\n  top: 1px;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n  color: rgba(218, 218, 218, 0.911);\r\n  font-size: small;\r\n  width: 96%;\r\n  /* font-family: console; */\r\n  font-family:  \"Roboto\" !important;\r\n  height: auto;\r\n  white-space: pre-wrap;\r\n  overflow-wrap: break-word;\r\n  box-sizing: border-box;\r\n}\r\n.contInputConsole{\r\n    width: 80%;\r\n    height: 70%;\r\n    /* background-color: aliceblue; */\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n.contActionsConsole{\r\n    width: 20%;\r\n    height: 70%;\r\n    background-color: rgb(42, 90, 131);\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.contInputConsole .lblConsole{\r\n     width: 10%;\r\n     height: 100%;\r\n     display: flex;\r\n     justify-content: center;\r\n     align-items: center;\r\n     color: rgb(141, 141, 141);\r\n     font-size: large;\r\n}\r\n\r\n.contInputConsole .inptConsole{\r\n    width: 80%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n.inptConsole input{\r\n    animation: 'pulse 1s infinite';\r\n        border-bottom: '1px solid aliceblue'; \r\n       width: 90%;\r\n       height: 50%;\r\n       background-color: transparent;\r\n       border-radius: 5px;\r\n       border-top: unset;\r\n       border-left: unset;\r\n       border-color: rgb(141, 141, 141);\r\n       color: aliceblue;\r\n}\r\n.inptConsole input:focus-visible{\r\n    border-top: unset;\r\n       border-left: unset;\r\n       border-color: rgba(1, 175, 206, 0.699);\r\n}\r\n.contConsolTitle{\r\n    width: 100%;\r\n    height: 10%;\r\n    color: var(--main-color);\r\n    font-size: var(--font-size-small);\r\n    position: absolute;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    top: 0;\r\n}\r\n@keyframes pulse {\r\n    0% {\r\n      color: #d41e1e; /* Color inicial */\r\n    }\r\n    50% {\r\n      color: transparent; /* Color transparente */\r\n    }\r\n    100% {\r\n      color: #000; /* Color final */\r\n    }\r\n  }\r\n\r\n  .contConsolTitle .cont-btn-back-users:hover{\r\n    background: transparent;\r\ncursor: unset;\r\n  }\r\n  .contConsolTitle .img-back-users:hover{\r\n    height: 85%;\r\n    cursor: pointer;\r\n  }\r\n  .contConsolText .xterm-viewport{\r\nbackground-color: transparent !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
